export default __webpack_public_path__ + "media/images/stripe-background-975dfffc3dabc6c7d0833264a7d2b185.png";